import React, {useCallback, useEffect, useRef, useState} from "react";
import styled, {css} from "styled-components";
import {useSearchParams} from "react-router-dom";

// Style
import {flex, z} from "../style/components/mixins.js";
import {border, heroTheme, pad} from "../style/components/variables.js";
import {Title, HeadingSmall, Text, Button, Anchor} from "../style/components/general.js";

const STORELINK = "https://apps.apple.com/app/id6532624467";

const APPBASE = "com.heroservices.herobuilderoperator://app-launch";

const AppLaunch = () => {
  const [searchParams] = useSearchParams();
  const [mobileLink, setMobileLink] = useState();

  const cleanup = useRef();

  const openAppWithFallback = useCallback(
    (fallback = true) => {
      if (cleanup.current) cleanup.current();

      const storeRedirect = setTimeout(() => {
        if (fallback) window.location.href = STORELINK;
      }, 3000);

      const enterprise = searchParams.get("enterprise");
      const token = searchParams.get("token");

      const appRedirect = setTimeout(() => {
        const link = `${APPBASE}?enterprise=${enterprise}&token=${token}`;
        setMobileLink(link);
        window.location.href = link;
      }, 0);

      const cleanupFunc = () => {
        clearTimeout(storeRedirect);
        clearTimeout(appRedirect);
        cleanup.current = undefined;
      };

      cleanup.current = cleanupFunc;

      return cleanupFunc;
    },
    [searchParams]
  );

  useEffect(() => {
    const cancel = openAppWithFallback(false);
    return cancel;
  }, [openAppWithFallback]);

  return (
    <MaintenancePage>
      <Header>
        <Logo src={`${process.env.PUBLIC_URL}/hero-services.png`} alt="Hero Services Logo" />
      </Header>
      <Title>Welcome to Hero Builder™</Title>
      <HeadingSmall>Opening in app...</HeadingSmall>
      <br />
      {mobileLink && (
        <Text center small>
          If nothing happens after several seconds,{" "}
          <Anchor href={mobileLink} inline plain quiet target="_blank" rel="noopener noreferrer">
            <Button
              inText
              plain
              quiet
              onClick={() => {
                openAppWithFallback();
              }}>
              click here
            </Button>
          </Anchor>
          .
        </Text>
      )}
    </MaintenancePage>
  );
};

// Style Overrides
const MaintenancePage = styled.section`
  ${flex("column", "wrap", "center", "center")};
  min-height: 100vh;
  height: 100%;
  padding: ${pad * 2}px;
`;

const Header = styled.nav`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  align-self: start;
  display: flex;
  background: ${heroTheme.secondary};
  z-index: ${z("top")};

  ${({theme}) =>
    theme.name === "dark" &&
    css`
      border-bottom: ${border} solid ${heroTheme.tertiary};
    `}
`;

const Logo = styled.img`
  height: 75px;
  margin: ${pad}px auto;
`;

export default AppLaunch;
